var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles } from '@mui/styles';
import classnames from 'classnames';
import React from 'react';
import RoundedButton from '../../components/Buttons/RoundedButton';
const useStyles = makeStyles(() => ({
    button: {
        position: 'relative',
        width: '100%',
        height: 56,
        paddingTop: 0,
        paddingRight: 20,
        paddingBottom: 0,
        paddingLeft: 20,
    },
}));
const ConversationButton = (_a) => {
    var { children, className } = _a, otherProps = __rest(_a, ["children", "className"]);
    const classes = useStyles();
    return (React.createElement(RoundedButton, Object.assign({ className: classnames(classes.button, className) }, otherProps, { disableRipple: true }), children));
};
export default ConversationButton;
